<!-- Unused file deprecated -->
<template>
  <div>{{ 'Component to list articles in a category in a portal' }}</div>
</template>
